import { Observable } from 'rxjs';
import { MockMode, MockUserMode } from '../../utility/mock-mode';

let _mockMode = MockMode.Off;
export function mockMode(mode = _mockMode) {
  _mockMode = mode;
  return _mockMode;
}

let _mockUserMode = MockUserMode.Full;
export function mockUserMode(mode = _mockUserMode) {
  _mockUserMode = mode;
  return _mockUserMode;
}

export function mockHandler<T>(arg: T, mode = _mockMode): Observable<T> {

  const delay = 11;

  // arg = JSON.parse(JSON.stringify(arg)); // TODO: Deep copy, but this requires implementing the update calls
  switch (mode) {
    case MockMode.Off: // Not valid, but happens from tests
    case MockMode.HappyPath:
      // return observableOf(arg);
      return new Observable(o => {
        setTimeout(() =>  o.next(arg), delay);
      });
    case MockMode.HappyDelayed:
      return new Observable(o => {
        setTimeout(() => o.next(arg), 3000);
      });
    case MockMode.ServerErrors:
      return new Observable(o => {
        setTimeout(() => o.error({ ok: false, status: 500, statusText: 'A Test Exception Occurred', type: 2 }), delay);
      });
    case MockMode.ServerErrorsDelayed:
      return new Observable(o => {
        setTimeout(() => o.error({ ok: false, status: 500, statusText: 'A Test Exception Occurred', type: 2 }), 2000);
      });
    case MockMode.Timeouts:
      return new Observable(o => {
        setTimeout(() => o.error({ ok: false, status: 0, statusText: '', type: 3 }), delay);
      });
    case MockMode.RandomErrors: { // Chaos monkey mode
      const enumValues = Object.keys(MockMode).map(n => Number.parseInt(n)).filter(n => !Number.isNaN(n) && n !== 0); // Exclude "Off"
      const randomValue = <MockMode>enumValues[Math.floor(Math.random() * enumValues.length)];
      return mockHandler(arg, randomValue);
    }
    case MockMode.BadRequest400:
      return new Observable(o => {
        setTimeout(() => o.error({ ok: false, status: 400, statusText: 'Bad Request', type: 2 }), delay);
      });
    case MockMode.Unauthorized401:
      return new Observable(o => {
        setTimeout(() => o.error({ ok: false, status: 401, statusText: 'Unauthorized', type: 2 }), delay);
      });
    case MockMode.Forbidden403:
      return new Observable(o => {
        setTimeout(() => o.error({ ok: false, status: 403, statusText: 'Forbidden', type: 2 }), delay);
      });
  }
}
